// extracted by mini-css-extract-plugin
module.exports = {"btn":"F_bl v_sf v_rS h_fq h_fF h_ft h_hg","full":"F_vp h_dq h_dB"};